import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
};

export const box: SxStyle = {
  display: 'flex',
};

export const item: SxStyle = {
  p: (p) => p.spacing(1.5, 1, 1.5, 1.5),
};
